import { Select, message } from "antd"
import React from "react"
import { doc, updateDoc } from "firebase/firestore"
import { db } from "../../../../firebase/config"

export default function ManufacturerSelect({ client, loading, manufacturerList }) {
  // When a manufacturer is selected, update the client document
  const handleManufacturerSelect = async (value) => {
    // Find the selected manufacturer from the list by its id
    const selectedManufacturer = manufacturerList.find((manufacturer) => manufacturer.id === value)

    if (!selectedManufacturer) {
      message.error("Selected manufacturer not found")
      return
    }

    try {
      // Update the client's manufacturer field in the "clients" collection
      const clientRef = doc(db, "clients", client.id)
      await updateDoc(clientRef, { manufacturer: selectedManufacturer })
      message.success("Manufacturer updated successfully")
    } catch (error) {
      console.error("Error updating manufacturer:", error)
      message.error("Failed to update manufacturer")
    }
  }

  return (
    <div>
      <Select
        value={client.manufacturer?.id} // use the manufacturer id as the value
        options={manufacturerList}
        loading={loading}
        fieldNames={{
          label: "company",
          value: "id",
        }}
        onChange={handleManufacturerSelect}
        style={{ minWidth: 150 }}
      />
    </div>
  )
}
